module.exports = __webpack_public_path__ + "static/media/betterflosspro-4.c48bec8d.jpg";